export const sort_up = () => (
  <path
    d="M12 19V5m0 0L8 9m4-4l4 4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
